import { createFileRoute, notFound } from '@tanstack/react-router'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_LEARNPATH } from '@/core/constants/features'
import { learnpathsQueries } from '@/http/api/learnpaths'
import { UsersLearningPathsList } from '@/users/components/UsersLearningPathsList/UsersLearningPathsList'

export const Route = createFileRoute(
  '/company/_management/users/$userId/learning-paths',
)({
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_LEARNPATH)) {
      throw notFound()
    }
  },
  loader: ({ context: { queryClient }, params }) =>
    queryClient.prefetchInfiniteQuery(
      learnpathsQueries.membershipsList(params.userId, { is_member: true }),
    ),
  component: UsersLearningPathsList,
  pendingComponent: LoadingIndicator,
})
